import { ChangeDetectionStrategy, Component, forwardRef, input, output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ExchangeLinkComponent } from '@features/exchange-link/exchange-link.component';

import { ToggleComponent } from '@shared/components/toggle/toggle.component';
import { CurrencyToggle } from '@shared/types/components.type';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToggleComponent, ExchangeLinkComponent],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleCurrencyComponent),
    },
  ],
  selector: 'aux-toggle-currency',
  template: `
    <div class="flex items-center gap-4">
      <div class="flex items-center space-x-2">
        <div>USD</div>
        <aux-toggle
          [value]="fc.value"
          (change)="
            nameSelectedCurrency.emit($event ? currencyToggle.CONTRACTED : currencyToggle.PRIMARY)
          "
        />
        <div>{{ currencyLabel() }}</div>
      </div>
      <aux-exchange-link />
    </div>
  `,
})
export class ToggleCurrencyComponent extends ToggleComponent {
  currencyLabel = input('Contracted Currency');

  nameSelectedCurrency = output<CurrencyToggle>();

  currencyToggle = CurrencyToggle;
}
